import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button }  from 'react-bootstrap';
import SearchInput,{ TYPE } from '../components/SearchInput.jsx';
import SearchAdvanced from '../components/SearchAdvanced.jsx';
import { useLoaderData, redirect, useNavigate } from 'react-router-dom';
import { loader_search_judgments,get_search_judgments,get_crimes } from '../api.js';
import JudgmentResolvedItem from '../components/JudgmentResolvedItem.jsx';
import Pagination from '../components/Pagination.jsx';
import { 
    is_authenticated, 
    auth_delete, 
    set_redirect_after_authenticate_cache
} from '../module/auth.js';

import { formatNumber } from '../utils/utils.js'

// import {  get_departments,get_municipalities } from '../api';

import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export const loader = async(data)=>{
    
    try{

        if(!is_authenticated()){
            console.log("no esta autenticado",data.request.url);
            set_redirect_after_authenticate_cache(data.request.url);
            return redirect("/login");
        }
        
        const response = await loader_search_judgments();
        return { data:response,error:null };
    }
    catch(err){

        if(err.status === 401){
            auth_delete();
            console.log("api send error authenticate")
            return redirect("/login");
        }

        return { data:null,error:err };
    }
    
}

function SearchOfResolveJudgments() {

    const loader = useLoaderData();
    const navigate = useNavigate();

    const [matters,set_matters] = useState([]);
    const [crimes,set_crimes] = useState([]);
    const [districts,set_districts] = useState([]);
    const [criteria,set_criteria] = useState([]);
    const [years,set_years] = useState([]);
    const [disabled,set_disabled] = useState(false);
    const [judgeds,set_judgeds] = useState([]);
    
    const [sentences,set_sentences] = useState({
        current_pag     :0,
        total_pages     :0,
        total_records   :0,
        records         :[]
    });

    const filter_default = {
        "filters": {
            "matter_id":null,//"0005",
            "district_id":null,//"0001",
            "department_id":null,//"0001",
            "municipality_id":null,//"0001",
            "judged_id":null,
            "date":null, //"2006-06-19",
            "year":null, //2009,
            "criteria":null, //"18,19",
            "crimes_id":null, //"1173",
            "keywords":null, //"Ana fernando",
            "comparative_law":null, //"1
            "multikeyword":null,
        },
        "pag": 0
    };

    const [input_search,set_input_search] = useState(filter_default);

    const comprative_law_input = React.createRef(null);

    const handle_on_search = ({key,value}) =>{
        
        set_input_search(prev_input_search =>{

            //los campos a buscar a borrar....
            const fields_filter = [TYPE.ALL,TYPE.SENTENCE_NUMBER,TYPE.RECORD_DATE,TYPE.MULTIKEYWORD];
    
            //obtengo todos los filtros....
            let filters = {...prev_input_search.filters}; //single

            for (let name in filters) {
                if(fields_filter.indexOf(name) !== -1){
                    filters[name] = null;
                }
            }
            
            filters[key] = value;

            return {
                ...prev_input_search,
                filters:filters,
                pag:0
            };
        });
       
    }

    const onSearch_advanced = async(key,item) =>{
        set_input_search((prev_input_search) =>{
            let filters = {...prev_input_search.filters};
            filters[key] = item !== null ? item.value : item;
            return {
                ...input_search,
                filters:filters,
                pag:0
            }
        });

        if(key === "matter_id"){
            if(item !== null){
                const new_crimes = await get_crimes(item.value);
                set_crimes(()=> new_crimes.map(crime =>{ return { value: crime.id, label: crime.text}}));
            }
            else{
                set_crimes(()=> []);
            }
        }
    }

    const onPage = (pag) =>{
       
        set_input_search(() =>{
            return {
                ...input_search,
                pag:pag
            };
        });
    }

    const onchange_searchInput = (input)=>{
        
        if(input === TYPE.SENTENCE_NUMBER){

            comprative_law_input.current.checked = false;
            set_input_search(()=> filter_default);
            set_disabled(()=> true);

        }
        else if(input === TYPE.RECORD_DATE){
            set_disabled(()=> false);
        }
        // else if(input === TYPE.MULTIKEYWORD){
        //     set_input_search(()=> filter_default);
        //     set_disabled(()=> false);
        // }
        else{
            set_disabled(()=> false);
        }
    }

    useEffect(()=>{
        get_search_judgments(input_search).then(sentences => set_sentences(sentences)).catch(err => console.log(err));
    },[input_search]);
    
    useEffect(()=>{

        if(loader !== undefined){
            if(loader.error === null){
                
                set_matters(loader.data.matters.map(matter =>{ return { value: matter.id, label: matter.text }}));
                set_districts(loader.data.districts.map(district =>{ return { value: district.id, label: district.text }}));
                set_criteria(loader.data.criterias.map(criteria =>{ return { value: criteria.id, label: criteria.text }}));
                set_years(loader.data.years.map(year =>{ return { value: year.id, label: year.text}}));
                set_judgeds(loader.data.judgeds.map(judged => { return { value: judged.Id_juzgado,label: judged.Juzgado }}))

            }
            else{
                set_matters([]); set_districts([]); set_criteria([]); set_years([]);
            } 
        }

    },[loader]);


  return (
    <Container fluid>
        <Row className='align-items-start'>
            <Col xs="2" sm="2" md="3" lg="3" xl="3" xxl="3" className="bg-body-tertiary p-0" style={{position:"relative",height:"70px"}} >
                
                <div style={{position:"absolute",width:"100%", top:"6px"}}>

                    <SearchAdvanced>
                       
                        <Row>
                            <Col sm='12' md='12' lg='12' xl='12' xxl='12'>
                                <h4 className='text-center mb-3'>Búsqueda avanzada</h4>
                            </Col>

                            <Col sm='12' md='12' lg='12' xl='12' xxl='12' className='p-2'>

                            <span className="form-group has-float-label">
                                <Select id='ddlMatters' tabSelectsValue={true} escapeClearsValue={true} options={matters} isClearable={true} placeholder={"Seleccione la materia"} onChange={(item) => onSearch_advanced("matter_id",item)}/>
                                <Form.Label htmlFor={"ddlMatters"}>Materias:</Form.Label>
                            </span>
                                
                            </Col>

                            <Col sm='12' md='12' lg='12' xl='12' xxl='12' className='p-2'>
                                <span className="form-group has-float-label">
                                    <Select id='ddlyear' tabSelectsValue={true} escapeClearsValue={true} options={years} isClearable={true} placeholder={"Seleccione el año"} onChange={(item) => onSearch_advanced("year",item)}/>
                                    <Form.Label htmlFor={"ddlyear"}>Año:</Form.Label>
                                </span>
                                
                            </Col>

                            <Col sm='12' md='12' lg='12' xl='12' xxl='12' className='p-2'>
                                <span className="form-group has-float-label">
                                    <Select id='ddljudged' tabSelectsValue={true} escapeClearsValue={true} options={judgeds} isClearable={true} placeholder={"Seleccione el órgano"} onChange={(item) => onSearch_advanced("judged_id",item)}/>
                                    <Form.Label htmlFor={"ddljudged"}>Órgano:</Form.Label>
                                </span>
                                
                            </Col>

                            <Col sm='12' md='12' lg='12' xl='12' xxl='12' className='p-2'>
                                <span className="form-group has-float-label">
                                    <Select id='ddlcriteria' tabSelectsValue={true} escapeClearsValue={true} options={criteria} isClearable={true} placeholder={"Seleccione un tema criterio"} onChange={(item) => onSearch_advanced("criteria",item)}/>
                                    <Form.Label htmlFor={"ddlcriteria"}>Criterio:</Form.Label>
                                </span>
                                
                            </Col>

                            <Col sm='12' md='12' lg='12' xl='12' xxl='12' className='p-2'>

                            <span className="form-group has-float-label">
                                <Select id='ddlcrimes' tabSelectsValue={true} escapeClearsValue={true} options={crimes}  isClearable={true} placeholder={"Seleccione una acción/delito"} onChange={(item) => onSearch_advanced("crimes_id",item)}/>
                                <Form.Label htmlFor={"ddlcrimes"}>Acción/Delito:</Form.Label>
                            </span>
                                
                            </Col>

                            <Col sm='12' md='12' lg='12' xl='12' xxl='12' className='p-2'>
                                <Form.Check 
                                    ref         =   { comprative_law_input }
                                    type        =   { "switch" }
                                    id          =   { "comparative_law" }
                                    disabled    =   { disabled }
                                    onChange    =   { (e) => onSearch_advanced("comparative_law",{value:e.target.checked === false ? null : e.target.checked}) }
                                    label       =   { "Sentencias con derecho comparado" }
                                />
                            </Col>
                        </Row>

                        <Row className='justify-content-center mt-4'>
                            <Col>
                                <Button variant="outline-secondary" className='d-table ms-auto me-auto' onClick={()=>navigate("/")}>
                                    <FontAwesomeIcon icon= { faArrowLeft }/>  Home
                                </Button>
                            </Col>
                            
                        </Row>

                    </SearchAdvanced>
                </div>
               
            </Col>
            <Col xs="10" sm="10" md="9" lg="9" xl="9" xxl="9" className="bg-body-tertiary p-3">

                <SearchInput onSearch={handle_on_search} onChange={onchange_searchInput}/>
               
            </Col>
        </Row>

        <Row className='justify-content-center' style={{minHeight:"100vh"}}>

            <Col md="3" lg="3" xl="3" xxl="3" className="bg-body-tertiary"></Col>

            <Col xs="11" sm="11" md="9" lg="9" xl="9" xxl="9" className="p-4">
                
                <Row>

                    <Col>
                        <p hidden={sentences.total_pages===0}>Resultado:  {formatNumber(sentences.total_records)} sentencias</p>
                        
                    </Col>

                    <Col>
                        <div className='d-table ms-auto me-auto'>
                            <Pagination onPage={onPage} current_pag={sentences.current_pag} total_pages={sentences.total_pages}/>
                        </div>
                        
                    </Col>

                    <Col>
                        <p style={{float:"right"}} hidden={sentences.total_pages===0}>página {formatNumber(sentences.current_pag + 1)} de {formatNumber(sentences.total_pages)}</p>
                    </Col>
                </Row>


                <Row>
                    <Col>
                        {sentences.records.map((sentence)=> (<JudgmentResolvedItem key={sentence.sent_id} judgment={sentence} />))}
                    </Col>
                </Row>

                <Row hidden={sentences.total_pages !==0 }>
                    <Col>
                        <p>No se encontraron resultados.</p>
                    </Col>
                </Row>

                <Row>

                    <Col>
                        <p hidden={sentences.total_pages===0} >Resultado:  {formatNumber(sentences.total_records)} sentencias</p>
                        
                    </Col>

                    <Col>
                        <div className='d-table ms-auto me-auto'>
                            <Pagination onPage={onPage} current_pag={sentences.current_pag} total_pages={sentences.total_pages}/>
                        </div>
                        
                    </Col>

                    <Col>
                        <p style={{float:"right"}} hidden={sentences.total_pages===0}>página {formatNumber(sentences.current_pag + 1)} de {formatNumber(sentences.total_pages)}</p>
                    </Col>
                </Row>
            </Col>

        </Row>

    </Container>
    )
}

export default SearchOfResolveJudgments